export const priorityMock = [
  { title: '1.Høy', value: '01 Høy', id: 'ct_69-3', color: '#eb5757' },
  { title: '2.Medium', value: '02 Medium', id: 'ct_69-2', color: '#f2994a' },
  { title: '3.Lav', value: '03 Lav', id: 'ct_69-1', color: '#f2c94c' },
];

// TODO: replace this with content fetched from backend!
// TODO: add color for each list value!
